import React, { ReactNode, useState, useEffect } from 'react'
import { MFExecutionContext } from '../contexts/MFExecutionContext'
import { useMFExecutionUI } from '../../hooks/mf-execution/useMFExecutionUI'
import { MFExecutionData } from '../../types/mf-execution.types'
import { fetchMFExecutionData } from '../../repository/mfExecution'
import { useQuery } from '@tanstack/react-query'
import { useMetaDataContext } from '../contexts/MetaDataContext'

interface MFExecutionProviderProps {
  children: ReactNode
}

const MFExecutionProvider: React.FC<MFExecutionProviderProps> = ({ children }) => {
  const { isin } = useMetaDataContext()
  const [hasError, setHasError] = useState(false)

  const {
    data: mfExecutionData,
    isLoading,
    isRefetching,
    isError,
    refetch: mfExecutionDataRefetch
  } = useQuery<MFExecutionData>({
    queryKey: ['mfExecutionData', isin],
    queryFn: () => fetchMFExecutionData(isin ?? '')
  })

  // Track error state persistently
  useEffect(() => {
    if (isError) {
      setHasError(true)
    } else if (mfExecutionData) {
      setHasError(false)
    }
  }, [isError, mfExecutionData, isRefetching])

  const { isActionsSheetOpen, isInfoSheetOpen, executionBarZIndex, executionBarConfig } = useMFExecutionUI(
    mfExecutionData || ({} as MFExecutionData)
  )

  return (
    <MFExecutionContext.Provider
      value={{
        mfExecutionData: mfExecutionData || ({} as MFExecutionData),
        isMFExecutionDataLoading: isLoading,
        isMFExecutionDataError: hasError,
        isActionsSheetOpen,
        isInfoSheetOpen,
        executionBarZIndex,
        executionBarConfig,
        mfExecutionDataRefetch
      }}
    >
      {children}
    </MFExecutionContext.Provider>
  )
}

export default MFExecutionProvider
